export default {
  CREATE_INVESTOR_GOAL_STATE_MANAGER: Symbol.for('CREATE_INVESTOR_GOAL_STATE_MANAGER'),
  MANAGE_TRACKING_INVESTOR_GOAL_STATE_MANAGER: Symbol.for('MANAGE_TRACKING_INVESTOR_GOAL_STATE_MANAGER'),
};
